import { Component, OnInit,  inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ArkUserType, ClientModel, ClientStatusViewModel, ClientUserViewModel, SupportTicketMetricsViewModel } from '../../core/api/models';
import { ClientsApiService, TicketsApiService } from '../../core/api/services';
import { Utils } from '../../core/utils';
import { AuthService } from '../../main/auth.service';
import { ClientService } from '../';
import { AlertService } from '../../shared/services/alert.service';
import { environment } from '../../../environments/environment';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-client-detail-component',
  templateUrl: './client-detail.component.html',
  styleUrl: './client-detail.component.css',
  standalone: false
})
export class ClientDetailComponent implements OnInit {

  
  currentItem?: ClientModel;
  loading = true;

  
  
  clientStatus: ClientStatusViewModel| null | undefined = null;
  
  clientLoginUrl: string | null | undefined = null;
  clientLoginVisible: boolean = false;
 
  get metrics(): SupportTicketMetricsViewModel | null { 
    return this.clientStatus?.TicketMetrics || null;
  }

  get clientUsers(): ClientUserViewModel[] | null { 
    return this.clientStatus?.Users|| null;
  }
  
  canImpersonate: boolean = false;
  saving = false;

  constructor(
    private readonly authService: AuthService,
    private readonly clientService: ClientService,
    private readonly route: ActivatedRoute,
    private readonly alertService: AlertService,
    private readonly apiService: ClientsApiService,
    private readonly ticketService: TicketsApiService
  ) {

  }

  ngOnInit(): void {
    this.authService.checkIfAutorized([ArkUserType.Admin]);
    this.canImpersonate=  this.authService.hasUserType(ArkUserType.Impersonator); 


    this.clientService.currentClient$.subscribe((client) => {
      this.load(client);
    });

    this.load(this.clientService.currentClient);
  }


  load(client?: ClientModel| null): void {
    if (!client)
    {
      this.alertService.error('Client not found.');
      return;
    }

    this.currentItem = client;
    

    // TO Filter by Client ID
    this.apiService.Status({clientID: this.currentItem?.ID || 0 })
      .forEach(
        (result) => {
          this.clientStatus = result;
          this.loading=false;

        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
            this.loading=false;
          });



  }

  getClientLogo(): string {
    return this.clientService.getClientLogo(this.currentItem || null) ;
  }


  impersonateClient() :void {
    this.clientLogin(null);
  }
  
  clientLogin(clientUser : ClientUserViewModel| null) :void {
    
    this.loading = true;
    this.apiService.GetImpersonationLink({ body: { clientID: this.currentItem!.ID || 0, client_userID: clientUser?.ID ||0 } }).forEach((r) => {
      this.loading = false;
      this.clientLoginUrl = r;
      var w = window.open(r, this.currentItem!.SiteName || '_blank');
      this.clientLoginVisible = (w == null);
      
    }).catch(
      err => {
        this.alertService.error(Utils.getAjaxError(err));
        this.loading = false;
      }).
      finally(() => {
      });

  }

  getProfileInitials(clientUser : ClientUserViewModel| null) :string {
    
     if (!clientUser)
      return 'XX';
    if (clientUser?.FirstName && clientUser?.FirstName.length > 0
      && clientUser?.LastName && clientUser?.LastName.length > 0)
      return (clientUser?.FirstName[0] + clientUser?.LastName[0]).toUpperCase();

    var temp = clientUser?.FirstName || clientUser?.UserName;
    if (temp && temp.length > 1)
      return temp[0].toUpperCase();
      
    return 'XX';
  }
  getTimeFromNow(date: Date | string |number | null | undefined) {
    if (!date) return '';

    var d = new Date(date);   
    if ((new Date().getTime()) - (d.getTime()) > 1000 * 60 * 60 * 36) {
      return formatDate(d, 'shortDate', 'en-US');
    }
    return Utils.getTimeFromNow(d);
  }
  formatMountainTime(date: Date| string | number | null| undefined) {
    if (!date) return '';
    return Utils.formatMountainTime(new Date(date));
  }
}
